module.exports = __webpack_public_path__ + "media/images/athletes/3472-53ccd7aa11e26652e6c1a04b7aec6d27.png";